import React from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import Typography, { Props as TypographyProps } from '@smart-tv/components/typography/typography';

import formatDate from '@smart-tv/utils/date/format-date';

import styles from './content-item.module.scss';

interface Props extends Omit<TypographyProps, 'children'> {
  startTime: Date;
  endTime: Date;
  trailingContent?: React.ReactNode;
}

export const ContentItemTimeSpan: React.FC<Props> = (props: Props) => {
  const { startTime, endTime, trailingContent, ...rest } = props;

  return (
    <Typography
      variant="caption"
      data-testid={testIds.contentItem.timespan}
      {...rest}
      component="div"
      className={styles['time-span']}
    >
      <span>
        {formatDate(startTime, 'hh:mm')} - {formatDate(endTime, 'hh:mm')}
      </span>
      {trailingContent}
    </Typography>
  );
};

export default React.memo(ContentItemTimeSpan);
